import React, { useState } from "react";
import PlayersBoard from "./PlayersBoard";
import { useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Players = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [turn, setTurn] = useState(state.firstname);
  const [playerOneCount, setPlayerOneCount] = useState(0);
  const [playerTwoCount, setPlayerTwoCount] = useState(0);
  const [playerOneRandom, setPlayerOneRandom] = useState(0);
  const [playerTwoRandom, setPlayerTwoRandom] = useState(0);
  const [playerOnesum, setPlayerOneSum] = useState([]);
  const [playerTwosum, setPlayerTwoSum] = useState([]);
  const [winPlayer, setWinPlayer] = useState("");
  const [win, setWin] = useState(false);
  const [lose, setLose] = useState();
  const [winnerScore, setWinnerScore] = useState([]);
  const [draw, setDraw] = useState(false);
  const [winFirst, setwinFirst] = useState(0);
  const [winSecond, setwinSecond] = useState(0);
  const [disableFirst, setdisableFirst] = useState(true);
  const [disableSecond, setdisableSecond] = useState(true);
  const [powerUp, setPowerUp] = useState(0);

  const p1_id = 0;
  const p2_id = 1;

  const handlePlayerOne = (id) => {
    if (id == 0) {
      setdisableFirst(false);
      setdisableSecond(true);
      setTurn(state.secondname);
      setPlayerOneCount(playerOneCount + 1);
      let random = 0;
      if (playerOnesum >= 45) {
        random = Math.floor(Math.random() * 3);
      } else {
        random = Math.floor(Math.random() * 10);
      }

      playerOnesum.push(random);
      const total = playerOnesum.reduce((pre, cur) => {
        return (pre = pre + cur);
      });

      setPlayerOneRandom(random);
      setPlayerOneSum([total]);

      if (total === 50) {
        setWin(true);
        setWinPlayer(state.firstname);
        setLose(state.secondname);
        setWinnerScore([
          ...winnerScore,
          { name: state.firstname, count: playerOneCount + 1 },
        ]);
        setwinFirst(winFirst + 1);
        localStorage.setItem("Player Name", JSON.stringify(state.firstname));
        localStorage.setItem("count", JSON.stringify(playerOneCount + 1));
      }
      if(total > 50 ){
        setDraw(true)
      }
     

    } else {
      setdisableSecond(false);
      setdisableFirst(true);
      setTurn(state.firstname);
      setPlayerTwoCount(playerTwoCount + 1);
      let random = 1;
      if (playerTwosum >= 45) {
        random = Math.floor(Math.random() * 3);
      } else {
        random = Math.floor(Math.random() * 10);
      }

      playerTwosum.push(random);
      const total = playerTwosum.reduce((pre, cur) => {
        return (pre = pre + cur);
      });

      setPlayerTwoRandom(random);
      setPlayerTwoSum([total]);
      if (total == 50) {
        setWin(true);
        setWinPlayer(state.secondname);
        setLose(state.firstname);
        setWinnerScore([
          ...winnerScore,
          { name: state.secondname, count: playerTwoCount + 1 },
        ]);
        setwinSecond(winSecond + 1);
        localStorage.setItem("Player Name", JSON.stringify(state.secondname));
        localStorage.setItem("count", JSON.stringify(playerTwoCount + 1));
      }
     if(total > 50 ){
       setDraw(true)
     }
    }

    
  };

  const PowerUpEven = () => {
    if (disableFirst == true) {
      setPowerUp(powerUp + 1);
      setdisableFirst(false);
      setdisableSecond(true);
      setTurn(state.secondname);
      setPlayerOneCount(playerOneCount + 1);
      let random = Math.floor(Math.random() * 10);
      if (random % 2 === 0) {
        random = random + 2;
      }
      if (random % 2 !== 0) {
        random = random + 1;
      }

      playerOnesum.push(random);
      const total = playerOnesum.reduce((pre, cur) => {
        return (pre = pre + cur);
      });

      setPlayerOneRandom(random);
      setPlayerOneSum([total]);

      if (total === 50) {
        setWin(true);
        setWinPlayer(state.firstname);
        setLose(state.secondname);
        setWinnerScore([
          ...winnerScore,
          { name: state.firstname, count: playerOneCount + 1 },
        ]);
        setwinFirst(winFirst + 1);
        localStorage.setItem("Player Name", JSON.stringify(state.firstname));
        localStorage.setItem("count", JSON.stringify(playerOneCount + 1));
      }
    } else {
      setPowerUp(powerUp + 1);
      setdisableSecond(false);
      setdisableFirst(true);
      setTurn(state.firstname);
      setPlayerTwoCount(playerTwoCount + 1);
      let random = Math.floor(Math.random() * 10);
      if (random % 2 === 0) {
        random = random + 2;
      }

      if (random % 2 !== 0) {
        random = random + 1;
      }

      playerTwosum.push(random);
      const total = playerTwosum.reduce((pre, cur) => {
        return (pre = pre + cur);
      });

      setPlayerTwoRandom(random);
      setPlayerTwoSum([total]);
      if (total === 50) {
        setWin(true);
        setWinPlayer(state.secondname);
        setLose(state.firstname);
        setWinnerScore([
          ...winnerScore,
          { name: state.secondname, count: playerTwoCount + 1 },
        ]);
        setwinSecond(winSecond + 1);
        localStorage.setItem("Player Name", JSON.stringify(state.secondname));
        localStorage.setItem("count", JSON.stringify(playerTwoCount + 1));
      }
    }
  };

  const PowerUpOdd = () => {
    if (disableFirst == true) {
      setPowerUp(powerUp + 1);
      setdisableFirst(false);
      setdisableSecond(true);
      setTurn(state.secondname);
      setPlayerOneCount(playerOneCount + 1);
      let random = Math.floor(Math.random() * 10);
      if (random % 2 === 0) {
        random = random + 1;
      } else {
        return random;
      }

      playerOnesum.push(random);
      const total = playerOnesum.reduce((pre, cur) => {
        return (pre = pre + cur);
      });

      setPlayerOneRandom(random);
      setPlayerOneSum([total]);

      if (total === 50) {
        setWin(true);
        setWinPlayer(state.firstname);
        setLose(state.secondname);
        setWinnerScore([
          ...winnerScore,
          { name: state.firstname, count: playerOneCount + 1 },
        ]);
        setwinFirst(winFirst + 1);
        localStorage.setItem("Player Name", JSON.stringify(state.firstname));
        localStorage.setItem("count", JSON.stringify(playerOneCount + 1));
      }

    } else {
      setPowerUp(powerUp + 1);
      setdisableSecond(false);
      setdisableFirst(true);
      setTurn(state.firstname);
      setPlayerTwoCount(playerTwoCount + 1);
      let random = Math.floor(Math.random() * 10);

      if (random % 2 === 0) {
        random = random + 1;
      } else {
        return random;
      }

      playerTwosum.push(random);
      const total = playerTwosum.reduce((pre, cur) => {
        return (pre = pre + cur);
      });

      setPlayerTwoRandom(random);
      setPlayerTwoSum([total]);
      if (total === 50) {
        setWin(true);
        setWinPlayer(state.secondname);
        setLose(state.firstname);
        setWinnerScore([
          ...winnerScore,
          { name: state.secondname, count: playerTwoCount + 1 },
        ]);
        setwinSecond(winSecond + 1);
        localStorage.setItem("Player Name", JSON.stringify(state.secondname));
        localStorage.setItem("count", JSON.stringify(playerTwoCount + 1));
      }
    }
  };

  const Restart = () => {
    setPlayerOneCount(0);
    setPlayerOneRandom(0);
    setPlayerOneSum([]);
    setPlayerTwoCount(0);
    setPlayerTwoRandom(0);
    setPlayerTwoSum([]);
    setWinPlayer("");
    setWin(false);
    setLose("");
    setDraw(false);
    setdisableFirst(true);
    setdisableSecond(true);
    setPowerUp(0);
    localStorage.removeItem("Player Name", JSON.stringify(state.firstname));
    localStorage.removeItem("count", JSON.stringify(playerOneCount + 1));
    localStorage.removeItem("Player Name", JSON.stringify(state.secondname));
    localStorage.removeItem("count", JSON.stringify(playerTwoCount + 1));
  };

  return (
    <div>
      <div className="score">
        <PlayersBoard
          winnerScore={winnerScore}
          winFirst={winFirst}
          winSecond={winSecond}
        />
      </div>

      <div className="game">
        <h3> Turns = {turn} </h3>
        <div style={{ margin: "20px", width: "50%", float: "left" }}>
          <h4 style={{ color: "blue" }}>Player 1 : {state.firstname} </h4>
          <h4>
            {state.firstname} Count : {playerOneCount}
          </h4>
          <h6>Random No : {playerOneRandom} </h6>
          <h6> Total Score : {playerOnesum} </h6>
          <Button
            variant="secondary"
            onClick={() => handlePlayerOne(p1_id)}
            disabled={ (playerOnesum >= 50 || !disableFirst && playerTwosum < 50 )}
          >
            First Player Roll
          </Button>{" "}
        </div>
        <div style={{ margin: "20px", float: "left" }}>
          <h4 style={{ color: "red" }}>Player 2 : {state.secondname} </h4>
          <h4> {state.secondname} Count : {playerTwoCount} </h4>
          <h6>Random No : {playerTwoRandom} </h6>
          <h6> Total Score : {playerTwosum} </h6>

          <Button
            variant="secondary"
            onClick={() => handlePlayerOne(p2_id)}
            disabled={(playerTwosum >= 50 || !disableSecond && playerOnesum < 50)}
          >
            Second Player Roll
          </Button>
        </div>
        <br />
        <br />
        <div style={{ width: "100%", marginTop: "160px" }}>
          <Button
            variant="secondary"
            onClick={() => PowerUpEven()}
            disabled={powerUp === 4}
          >
            Power Up Even
          </Button>
          {"   "}
          <Button
            variant="secondary"
            onClick={() => PowerUpOdd()}
            disabled={powerUp === 4}
          >
            Power Up Odd
          </Button>
        </div>

        <br />

        {win && (
          <>
            <h5>{winPlayer} you Win the game </h5>
            <h5 style={{ color: "blue" }}>{winPlayer} Congratulation</h5>
            <h5> {lose} You Lost the Game try Again</h5>
            <Button variant="outline-secondary" onClick={() => Restart()}>
              Restart Game
            </Button>{" "}
            {"  "}
            <Button variant="primary" onClick={() => navigate("/")}>
              Reset
            </Button>
          </>
        )}
        {draw && (
          <>
            <h5> Draw the game ooppppssss!!!!!!!! try Again</h5>
            <Button variant="outline-secondary" onClick={() => Restart()}>
              Restart Game
            </Button>
            {"  "}
            <Button variant="primary" onClick={() => navigate("/")}>
              Reset
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default Players;
